import firebase from 'firebase';
//DO NOT FORGET TO CHANGE rules TO != from === after EVERYTHING IS DONE
// Initialize Firebase
var config = {
    apiKey: "AIzaSyAwgYVEdD8E3zD3w4SRZhgAfiDy2nayfdw",
    appId: "1:50131116809:web:805f2b0fd691c2c301e9d8",
    authDomain: "notesynct.firebaseapp.com",
    databaseURL: "https://notesynct.firebaseio.com",
    messagingSenderId: "50131116809",
    projectId: "notesynct",
    storageBucket: "notesynct.appspot.com",
};
// export var firebaseApp = firebase.initializeApp(config);
var firebaseApp = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();
export default firebaseApp;


// WEBPACK FOOTER //
// ./src/Components/Firebase/Firebase.js